import React from 'react'
import moment from 'moment-timezone'
import { callFollowUpIcon } from 'src/designSystem/icons'
import { VideoCallType } from 'src/graphql.generated'
import IndicatorChip from './IndicatorChip'
import { CALL_LABELS } from './callTodayUtils'

type Props = {
  callType: VideoCallType
  startTime: Date
  expanded?: boolean
}

const callFollowUpLabel = (callType: VideoCallType, startTime: Date): string =>
  `${CALL_LABELS[callType]} on ${moment(startTime).format('ll')} – note not submitted`

const CallFollowUpIndicator = ({ callType, startTime, expanded = false }: Props) => (
  <IndicatorChip
    tooltip={callFollowUpLabel(callType, startTime)}
    label={expanded ? 'Call follow-up' : undefined}
    testId="call-follow-up-indicator"
  >
    <img src={callFollowUpIcon} alt="" />
  </IndicatorChip>
)

export default CallFollowUpIndicator
